module.exports = __webpack_public_path__ + "images/sms_cta.png";